import React, { Component } from 'react';
import Select from 'react-select';
// import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Collapse } from 'react-collapse';
import 'react-select/dist/react-select.css';

import FormYearsRow from './components/FormYearsRow';
import containerActions from '../../actions';

import imgSwitch from './img/switch.png';
import './styles.scss';

const productLifeTimePeriodYears = 20;

class Settings extends Component {
  constructor () {
    super();
    this.state = {
      collapseOpen: [false, false],
      productLifeTime: 13,
      arrRulesObj: [],
      minLeaseTerm: 1,
      maxLeaseTerm: 1,
      leasetermStrDescr: ''
    };
  }
  componentDidMount() {
    this.ifarrObjEmpty();
  }
  ifarrObjEmpty = () => {
    let buffObj = {};
    if (this.state.arrRulesObj.length === 0) {
      buffObj = {
        minValue: 1,
        maxValue: this.state.productLifeTime - this.state.minLeaseTerm,
        minValueSel: 1,
        maxValueSel: this.state.productLifeTime - this.state.minLeaseTerm
      };
    }
    this.setState({
      arrRulesObj: this.arrRulesObjCalculation([buffObj], 0)
    });
  }
  arrRulesObjCalculation = (
    arrObj,
    editedElement,
    newproductLifeTime,
    newMaxLeaseTerm,
    newMinLeaseTerm
  ) => {
    const buffArrObj = arrObj;
    // change the date in neighboring records
    Object.keys(buffArrObj).forEach((element, index) => {
      if (buffArrObj[index - 1] && editedElement === index) {
        buffArrObj[index - 1].maxValue = buffArrObj[index].minValue - 1;
      }
      if (buffArrObj[index + 1] && editedElement === index) {
        buffArrObj[index + 1].minValue = buffArrObj[index].maxValue + 1;
      }
    });
    // delete records where the dates overlap
    if (buffArrObj[editedElement - 1]) {
      if (buffArrObj[editedElement - 1].minValue === buffArrObj[editedElement].minValue) {
        buffArrObj.splice(editedElement - 1, 1);
      }
    }
    if (buffArrObj[editedElement + 1]) {
      if (buffArrObj[editedElement + 1].minValue === buffArrObj[editedElement].maxValue) {
        buffArrObj.splice(editedElement + 1, 1);
      }
    }
    Object.keys(buffArrObj).forEach((element, index) => {
      if (buffArrObj[index]) {
        if (buffArrObj[index].minValue > buffArrObj[index].maxValue) {
          buffArrObj.splice(index, 1);
        }
      }
    });

    // define the limits
    Object.keys(buffArrObj).forEach((element, index) => {
      if (buffArrObj[index - 1]) {
        buffArrObj[index].minValueSel = buffArrObj[index - 1].minValue;
      } else {
        buffArrObj[index].minValueSel = buffArrObj[index].minValue;
      }
      if (buffArrObj[index + 1]) {
        buffArrObj[index].maxValueSel = buffArrObj[index + 1].maxValue;
      } else {
        buffArrObj[index].maxValueSel = this.state.productLifeTime - (
          newMinLeaseTerm ||
          this.state.minLeaseTerm
        );
      }
    });
    // Define the first and last record, prohibit editing
    Object.keys(buffArrObj).forEach((element, index) => {
      if (buffArrObj[index].minValue === 1) {
        buffArrObj[index].positionMin = true;
      } else {
        buffArrObj[index].positionMin = false;
      }
      if (
        buffArrObj[index].maxValue === this.state.productLifeTime - (
          newMinLeaseTerm ||
          this.state.minLeaseTerm
        )
      ) {
        buffArrObj[index].positionMax = true;
      } else {
        buffArrObj[index].positionMax = false;
      }
    });
    // Define lease term
    Object.keys(buffArrObj).forEach((element, index) => {
      buffArrObj[index].minLeaseTerm = newMinLeaseTerm || this.state.minLeaseTerm;
      const maxLeaseTerm = newMaxLeaseTerm || this.state.maxLeaseTerm;
      // if (productLifeTime === newproductLifeTime) {
      //   productLifeTime += 1;
      // }

      if ((this.state.productLifeTime - buffArrObj[index].maxValue) > maxLeaseTerm) {
        buffArrObj[index].maxLeaseTerm = maxLeaseTerm;
      } else {
        buffArrObj[index].maxLeaseTerm = this.state.productLifeTime - buffArrObj[index].maxValue;
      }
      if (('selectLeaseTerm' in buffArrObj[index]) === false) {
        buffArrObj[index].selectLeaseTerm = this.state.productLifeTime - buffArrObj[index].maxValue;
      }
      if (buffArrObj[index].selectLeaseTerm > buffArrObj[index].maxLeaseTerm) {
        buffArrObj[index].selectLeaseTerm = buffArrObj[index].maxLeaseTerm;
      }
      if (buffArrObj[index].selectLeaseTerm < buffArrObj[index].minLeaseTerm) {
        buffArrObj[index].selectLeaseTerm = buffArrObj[index].minLeaseTerm;
      }
    });
    return buffArrObj;
  }
  changeField = (element, min, max) => {
    const arrBuff = this.state.arrRulesObj;
    arrBuff[element].minValue = min;
    arrBuff[element].maxValue = max;

    this.setState({
      arrRulesObj: this.arrRulesObjCalculation(arrBuff, element)
    });
  }
  delRow = (index) => {
    const buffArr = this.state.arrRulesObj;
    buffArr.splice(index, 1);
    console.log(`${buffArr.length} ${index}`);
    if (buffArr.length === index) {
      buffArr[index - 1].maxValue = this.state.productLifeTime - this.state.minLeaseTerm;
      this.setState({
        arrRulesObj: this.arrRulesObjCalculation(buffArr, index - 1)
      });
      return false;
    }
    this.setState({
      arrRulesObj: this.arrRulesObjCalculation(buffArr, index)
    });
    return false;
  }
  addRule = () => {
    const buffArr = this.state.arrRulesObj;
    let changeIndex = -1;
    buffArr.reverse().forEach((element, index) => {
      if (changeIndex === -1) {
        if (element.minValueSel + 1 < element.minValue) {
          changeIndex = buffArr.length - index;
        }
      }
    });
    buffArr.reverse().forEach((element, index) => {
      if (changeIndex !== -1) {
        if (index - 1 === changeIndex - 2) {
          if (buffArr[index - 1]) {
            buffArr[index - 1].maxValue -= 1;
          }
        }
        if (index >= changeIndex - 1) {
          buffArr[index].minValue -= 1;
          buffArr[index].maxValue -= 1;
        }
      }
    });
    buffArr.push({
      minValue: this.state.productLifeTime - this.state.minLeaseTerm,
      maxValue: this.state.productLifeTime - this.state.minLeaseTerm,
      minValueSel: this.state.productLifeTime - this.state.minLeaseTerm,
      maxValueSel: this.state.productLifeTime - this.state.minLeaseTerm
    });
    this.setState({
      arrRulesObj: this.arrRulesObjCalculation(buffArr, buffArr.length - 1)
    });
  }
  updateProdLifeTime = (newMinLT) => {
    const buffArr = this.state.arrRulesObj;
    const inputData = this.state.productLifeTime - (newMinLT || this.state.minLeaseTerm);
    if (inputData < buffArr[buffArr.length - 1].maxValue) {
      let findElement = -1;
      buffArr.forEach((element, index) => {
        if (element.maxValue > inputData) {
          if (findElement === -1) {
            findElement = index;
          }
        }
      });
      if (findElement !== -1) {
        if (findElement === 0) {
          buffArr.splice(findElement + 1, buffArr.length - findElement);
        } else {
          buffArr.splice(findElement, buffArr.length - findElement);
        }
        if (buffArr[findElement]) buffArr[findElement].maxValue = inputData;
      }
    }
    if (inputData >= buffArr[buffArr.length - 1].maxValue) {
      buffArr[buffArr.length - 1].maxValue = inputData;
      buffArr[buffArr.length - 1].maxValueSel = inputData;
      buffArr[buffArr.length - 1].positionMax = true;
    }
    if (newMinLT) {
      this.setState({
        arrRulesObj: this.arrRulesObjCalculation(
          buffArr,
          buffArr.length - 1,
          inputData,
          null,
          newMinLT
        )
      });
    } else {
      this.setState({
        arrRulesObj: this.arrRulesObjCalculation(
          buffArr,
          buffArr.length - 1,
          inputData
        )
      });
    }

    if (this.state.maxLeaseTerm > this.state.productLifeTime) {
      this.changeMaxLeaseTerm({ value: this.state.productLifeTime });
    }
  }
  changeProductLifeTimePeriod = (value) => {
    this.setState({
      productLifeTime: value.value
    });
  }
  productLifeTimePeriod = () => {
    let counter = this.state.minLeaseTerm + 1;
    const arrayValue = [];
    do {
      arrayValue.push({
        label: counter,
        value: counter
      });
      counter += 1;
    }
    while (counter <= productLifeTimePeriodYears);
    return arrayValue;
  }
  minLeaseTermOptions = () => {
    const buffArr = [];
    let counter = 1;
    do {
      buffArr.push({
        label: counter * 12,
        value: counter
      });
      counter += 1;
    }
    while (counter <= this.state.maxLeaseTerm);
    return buffArr;
  }
  maxLeaseTermOptions = () => {
    const buffArr = [];
    let counter = this.state.minLeaseTerm;
    do {
      buffArr.push({
        label: counter * 12,
        value: counter
      });
      counter += 1;
    }
    while (counter <= this.state.productLifeTime - 1);
    return buffArr;
  }
  changeMinLeaseTerm = (e) => {
    this.setState({
      minLeaseTerm: e.value
    });
    this.updateProdLifeTime(e.value);
  }
  changeMaxLeaseTerm = (e) => {
    this.setState({
      maxLeaseTerm: e.value,
      arrRulesObj: this.arrRulesObjCalculation(
        this.state.arrRulesObj,
        this.state.arrRulesObj.length - 1, null, e.value
      )
    });
  }
  changeLeaseTerm = (e, id) => {
    const arrBuff = this.state.arrRulesObj;
    arrBuff[id].selectLeaseTerm = e.value;
    this.setState({
      arrRulesObj: this.arrRulesObjCalculation(arrBuff, arrBuff.length - 1)
    });
  }
  genDescSrtingLeaseTerm = () => {
    let buffStr = '';
    Object.keys(this.state.arrRulesObj).forEach((element, index) => {
      buffStr += ` ${this.state.arrRulesObj[index].minValue}-${this.state.arrRulesObj[index].maxValue} years = ${this.state.arrRulesObj[index].selectLeaseTerm * 12} months`;
      if (index !== this.state.arrRulesObj.length - 1) {
        buffStr += ',';
      }
    });
    if (buffStr.length > 98) {
      buffStr = `${buffStr.slice(0, 98)}...`;
    }
    this.setState({
      leasetermStrDescr: buffStr
    });
  }

  collapseOpenToggle = (n) => {
    const buff = this.state.collapseOpen;
    if (buff[n] === false) {
      buff.fill(false);
      buff[n] = true;
    } else if (buff[n] === true) {
      buff.fill(false);
    }

    this.setState({
      collapseOpen: buff
    });
  }
  render() {
    return (
      <div className="body-settings">
        <div className="heder-settings">
          <p>Settings</p>
        </div>
        <div className="page-settings">
          <div className="page-settings-head">
            Calculation
          </div>
          <div className="page-menuElement">
            <div className="page-menuElement-items">
              <p>Product lifetime</p>
              <p className="description-item -right" >{this.state.collapseOpen[0] ? '' : `${this.state.productLifeTime} years`}</p>
              <button onClick={() => this.collapseOpenToggle(0)}>
                <img src={imgSwitch} alt="imgSwitch_pic" />
              </button>
            </div>
            <Collapse isOpened={this.state.collapseOpen[0]}>
              <div className="collapse-menuElement-items">
                <div>
                  <div>Product lifetime</div>
                  <Select
                    className="from-FormYear"
                    value={this.state.productLifeTime}
                    onChange={this.changeProductLifeTimePeriod}
                    options={this.productLifeTimePeriod()}
                    clearable={false}
                    searchable={false}
                    menuBuffer={10}
                  />
                  <div>
                    {' years'}
                  </div>
                </div>
                <div className="func-button">
                  <button onClick={() => this.collapseOpenToggle(0)}>CANCEL</button>
                  <button onClick={() => this.updateProdLifeTime()} >UPDATE</button>
                </div>
              </div>
            </Collapse>
          </div>
          <div className="page-menuElement">
            <div className="page-menuElement-items">
              <p>Lease term</p>
              <p className="description-item" >{this.state.collapseOpen[1] ? 'Depends on the age of a car' : `Depends on the age of a car: ${this.state.leasetermStrDescr}`}</p>
              <button onClick={() => this.collapseOpenToggle(1)}>
                <img src={imgSwitch} alt="imgSwitch_pic" />
              </button>
            </div>
            <Collapse isOpened={this.state.collapseOpen[1]}>
              <span />
              <div className="lease-term">
                <p>Minimal lease term</p>
                <Select
                  className="from-FormYear"
                  value={{
                    value: this.state.minLeaseTerm,
                    label: this.state.minLeaseTerm * 12
                  }}
                  onChange={this.changeMinLeaseTerm}
                  options={this.minLeaseTermOptions()}
                  clearable={false}
                  searchable={false}
                  menuBuffer={10}
                />
                <p>months ({this.state.minLeaseTerm} years)</p>
              </div>
              <div className="lease-term">
                <p>Maximum lease term</p>
                <Select
                  className="from-FormYear"
                  value={{
                    value: this.state.maxLeaseTerm,
                    label: this.state.maxLeaseTerm * 12
                  }}
                  onChange={this.changeMaxLeaseTerm}
                  options={this.maxLeaseTermOptions()}
                  clearable={false}
                  searchable={false}
                  menuBuffer={10}
                />
                <p>months ({this.state.maxLeaseTerm} years)</p>
              </div>
              <div className="description-menuElement">
                <p>Age of a car</p>
                <p>Lease term</p>
              </div>
              {Object.keys(this.state.arrRulesObj).map((element, index) =>
                (<FormYearsRow
                  key={Math.random()}
                  id={index}
                  data={this.state.arrRulesObj[element]}
                  changeField={this.changeField}
                  disableDel={Object.keys(this.state.arrRulesObj).length > 1}
                  delRow={this.delRow}
                  changeLeaseTerm={this.changeLeaseTerm}
                />))
              }
              <div className="add-button">
                <button onClick={this.addRule} ><span>+</span> <span>ADD RULE</span></button>
              </div>
              <div className="func-button">
                <button onClick={() => this.collapseOpenToggle(1)}>CANCEL</button>
                <button onClick={() => { this.genDescSrtingLeaseTerm(); }}>UPDATE
                </button>
              </div>
            </Collapse>
          </div>
        </div>
      </div>
    );
  }
}

Settings.propTypes = {

};
const mapStateToProps = state => ({
  carData: state.careditor.pagesData.carData
});

export default connect(mapStateToProps, containerActions)(Settings);



// WEBPACK FOOTER //
// ./src/pages/CarEditorPage/components/Settings/index.js